<template>
  <div class="location-items">
    <div class="col-12 col-md-6" v-for="country in sortedCountries" :key="country.id">
      <div class="location-items-group">

        <div class="col-1 select-item">
          <label class="custom-label">
            <input type="checkbox" name="filter_country"
                   :checked="filterData.country.some(c => c.id === country.id)"
                   @change="toggleMultiple('country', country)">
            <span class="checkmark"></span>
          </label>
        </div>

        <div class="col-2 image-item">
          <figure>
            <img :src="`/img/flags/New${country.code.toUpperCase()}.png?v=2`"
                 :alt="country.title"
                 @click="() => {filterData.country = [country]; afterSelectAction()}"
                 class="place-img img-cover" width="64" height="64">
          </figure>
        </div>

        <div class="col-8 title-item" @click="() => {filterData.country = [country]; afterSelectAction()}">
            <span class="country-title">{{country.langtitle[activeLocale.code] ?? country.title }}</span>
            <span class="offer-count d-block">{{ country.count_of_accommodations }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import PlaceCountry from "../../../../../lib/models/PlaceCountry";

const props = defineProps({
  countries: Array<PlaceCountry>,
  filterData: {},
  activeCountry: { title: String, id: String, code: String },
  activeLocale: { title: String, id: String, code: String },
  toggleMultiple: Function,
});
const emit = defineEmits(['selectAction']);

const afterSelectAction = () => {
  emit('selectAction');
}

const sortedCountries = computed(() => {
  return [...props.countries].sort((a, b) => {
    if (a.code === props.activeCountry.code) {
      return -1;
    }
    return a.count_of_accommodations > b.count_of_accommodations ? 0 : 1;
  });
});
</script>
